
import {Component, Vue} from 'vue-property-decorator'
import { Form } from 'vant'

@Component
export default class GoodsSpecValueForm extends Vue {
  visible = false
  type = ''
  specValueIndex = 0
  specIndex = 0
  allSpecAttrValue: string[] = []
  form = {
    attrValue: ''
  }

  showModal (type = 'add', specIndex: number, allSpecAttrValue: string[], attrValue?: string, specValueIndex?: number) {
    this.resetField()
    this.type = type
    this.specValueIndex = specValueIndex
    this.specIndex = specIndex
    this.allSpecAttrValue = allSpecAttrValue
    this.form.attrValue = attrValue
    this.visible = true
  }
  resetField () {
    this.form.attrValue = ''
  }
  handleCancel () {
    this.visible = false
  }
  validateForm () {
    return new Promise(resolve => {
      (this.$refs.form as Form).validate().then(() => {
        resolve(true)
      })
    })
  }
  async onSubmit () {
    await this.validateForm()
    this.$emit('on-submit', this.type, this.specIndex, this.form, this.specValueIndex)
    this.visible = false
  }
}
